export default __webpack_public_path__ + "static/media/guide_index.4a99ed62.md";